/* eslint-disable no-undef */
// import {cmsId} from '../db/cmsId';
import easing from 'easing-js';
import dropdown from './dropdown';
import _throttle from 'lodash.throttle';
import helpers from '../helpers';
import vars from '../helpers';
import scrollToAnchor from '../modules/scrollToAnchor';
import {agentsPage} from './request-simple';

const hash = window.location.hash;
const offsetAnimate = 600;
const anchorSpeed = 1000;
const $header = document.querySelector('.header');
const scrollContainer = document.querySelector('#scroll');
const isFixed = () => $header.classList.contains('header--fixed');
const aosItems = document.querySelectorAll('[data-aos]');

let headerHeight = $header.clientHeight;
let statsPercent = false;
let hashChange = true;

const refresh = _throttle((el) => {
	el.classList.add('aos-animate');

	AOS.refresh();
}, 100);

const changeFixedState = (state) => {
	if (state) {
		$header.classList.remove('header--disable-fixed');
		$header.classList.add('header--fixed');
	} else {
		$header.classList.remove('header--fixed');
		$header.classList.add('header--disable-fixed');
	}
};

const changeFixedStateOnScroll = () => {
	let pageYOffset = window.pageYOffset;
	let pageTop = vars.isMobile() ? pageYOffset : scrollbar.scrollTop;

	if (pageTop > headerHeight && !isFixed()) {
		changeFixedState(true);
	} else if (pageTop <= headerHeight && isFixed()) {
		changeFixedState(false);
	}
};

const refreshHeader = _throttle(() => {
	changeFixedStateOnScroll();
}, 100);

const goToAnchor = (e) => {
	let id = $(e.currentTarget).attr('href');
	const speed = $(e.currentTarget).data('speed') || anchorSpeed;
	const dataOffset = $(e.currentTarget).data('offset') || 0;

	if (vars.isMobile()) {
		scrollToAnchor.scroll(e);
	} else {
		let idOffset = $(id).offset().top;
		let offset = idOffset + dataOffset + (scrollbar.scrollTop - headerHeight);

		scrollbar.scrollTo(0, offset, speed, {
			easing: easing.easeInOut,
		});
	}
};

const hashToAnchor = (id) => {
	if (vars.isMobile()) {
		const offset = helpers.$header.css('position') === 'fixed' || helpers.$header.css('position') === 'absolute' ? -helpers.$header.outerHeight(true) : 0;
		helpers.scrollTo(id, speed, offset);
	} else {
		if (id.closest('.service__side-block')) {
			id = document.querySelector(`#service-content #${id.id}`);
		}

		// const idOffset = id.getBoundingClientRect().top;
		// const offset = idOffset + (scrollbar.scrollTop - headerHeight);

		// scrollbar.scrollTo(0, offset, anchorSpeed, {
		// 	easing: easing.easeInOut,
		// });

		scrollbar.scrollIntoView(id, {
			offsetTop: -scrollbar.containerEl.scrollTop + headerHeight,
		});
	}
};

// const refreshTitle = (el) => {
// 	let top = headerHeight + 20;
// 	let id = el.id;
// 	let offset = el.getBoundingClientRect();
// 	let currentOffset = offset.top;

// 	if (currentOffset < top) {
// 		cmsId.forEach((element) => {
// 			if (element.id === id) {
// 				document.title = element.title;
// 			}
// 		});
// 	}
// };

function fixSideMenu(menu, parrent, offset, offsetScroll, paddingTop) {
	if (menu && !vars.isMobile()) {
		if (parrent.getBoundingClientRect().top - offsetScroll + paddingTop < 0
			&& parrent.getBoundingClientRect().bottom - window.innerHeight > 0) {
			menu.classList.add('fix');
			menu.style.top = `${offset.y}px`;
		} else if (parrent.getBoundingClientRect().top - offsetScroll >= 0) {
			menu.classList.remove('fix');
			menu.style.top = `${paddingTop}px`;
		}
	}
}

const init = () => {
	helpers.$header = $('.header');
	scrollbar.track.xAxis.element.remove();

	const sideMenu = document.querySelector('.service__side-block-wrapper');
	const parent = sideMenu ? sideMenu.parentNode : null;
	let offsetScroll = sideMenu ? parent.getBoundingClientRect().top : null;
	let paddingTop = sideMenu ? Number(window.getComputedStyle(parent, null).getPropertyValue('padding-top').replace('px', '')) : null;

	scrollbar.addListener((status) => {
		let offset = status.offset;
		let limit = scrollbar.limit.y;
		let top = offset.y;
		let percent = top * 100 / limit;

		// $('.header').css('transform', `translateY(${offset.y}px)`);

		$header.style.top = `${offset.y}px`;
		// $header.style.left = `${offset.x}px`;

		if (percent >= 70 && !statsPercent) {
			if (agentsPage) {
				ym(25538402, 'reachGoal', 'scroll70');
				gtag('event', 'page70', {
					event_category: 'scroll',
					event_label: 'label',
					value: 'value',
				});

				statsPercent = true;
			} else {
				ym(25538402, 'reachGoal', 'scroll70');
				// ga('send', 'event', 'scroll', 'page70');

				statsPercent = true;
			}
		}

		refreshHeader();
		fixSideMenu(sideMenu, parent, offset, offsetScroll, paddingTop);
	});

	if (vars.isMobile()) {
		window.addEventListener('scroll', _throttle(changeFixedStateOnScroll, 100), false);
	}

	if (aosItems) {
		[].forEach.call(aosItems, (el) => {
			scrollbar.addListener(() => {
				if (!vars.isMobile()) {
					if (scrollbar.isVisible(el)) {
						let offset = el.getBoundingClientRect();
						let currentOffset = offset.top;

						if (currentOffset < offsetAnimate && !el.classList.contains('aos-animate')) {
							refresh(el);
						}
					}
				}
			});
		});
	}

	// const cmsItems = document.querySelectorAll('.cms-item');

	// if (cmsItems) {
	// 	[].forEach.call(cmsItems, (el) => {
	// 		scrollbar.addListener(() => {
	// 			if (!vars.isMobile()) {
	// 				if (scrollbar.isVisible(el)) {
	// 					refreshTitle(el);
	// 				}
	// 			}
	// 		});
	// 	});
	// }

	// localStorage.setItem('scroll', 'custom');

	// if (localStorage.getItem('scroll')) {
	// 	scrollbar.update();
	// }

	document.addEventListener('DOMContentLoaded', () => {
		if (scrollbar.containerEl === scrollContainer) {
			if (hash) {
				const target = document.getElementById(hash.substring(1));
				const pageCms = document.querySelector('.page-service-connection-cms');

				if (pageCms) {
					const dropdownBtn = document.querySelector('.service__main-content-cms>.drop-down-js');

					if (!dropdownBtn.classList.contains('is-active')) {
						dropdown.toggleClass(dropdownBtn);
					}
				}

				if (target) {
					setTimeout(() => {
						scrollbar.update();
						hashToAnchor(target);
					}, 500);
				}
			}
		}
	});

	window.addEventListener('hashchange', () => {
		if (hashChange) {
			let updateHash = window.location.hash;

			if (updateHash) {
				const target = document.getElementById(updateHash.substring(1));

				if (target) {
					setTimeout(() => {
						scrollbar.update();
						hashToAnchor(target);
					}, 500);
				}
			}
		}
	}, false);

	helpers.$document.on('click.anchor', '.js-to-anchor', (e) => {
		e.preventDefault();
		e.stopPropagation();

		goToAnchor(e);
	});

	helpers.$document.on('click.anchor', '.js-cms-to-anchor', (e) => {
		e.preventDefault();
		e.stopPropagation();

		const dropdownBtn = document.querySelector('.service__main-content-cms>.drop-down-js');

		if (!dropdownBtn.classList.contains('is-active')) {
			dropdown.toggleClass(dropdownBtn);
		}

		setTimeout(() => {
			scrollbar.update();
			goToAnchor(e);
		}, 500);
	});

	$('.service__main-content-cms .drop-down-js').on('click', () => {
		setTimeout(() => {
			scrollbar.update();
		}, 500);
	});
};

export default {
	init,
};
